export const drawFieldPage = (
	field: CanvasRenderingContext2D,
	width: number,
	height: number
) => {
	field.clearRect(0, 0, width, height);
	field.fillStyle = "#005700"; // "pine" color we use for jerseys
	field.fillRect(0, 0, width, height);
	field.strokeStyle = "rgb(254 254 254 / 35%)"; // "snow" color
	field.lineWidth = 1;

	// Main field markings
	field.strokeRect(1, 1, width - 2, height - 2);

	// Center elements
	field.beginPath();
	field.arc(width / 2, height / 2, 80, 0, Math.PI * 2);
	field.stroke();
	field.beginPath();
	field.moveTo(width / 2, 1);
	field.lineTo(width / 2, height - 1);
	field.stroke();
	field.fillStyle = "rgb(254 254 254 / 35%)"; // "snow" color
	field.beginPath();
	field.arc(width / 2, height / 2, 3, 0, Math.PI * 2);
	field.fill();

	// Penalty areas (left and right)
	const penaltyAreaWidth = 140;
	const penaltyAreaHeight = 300;
	// Left penalty area
	field.strokeRect(
		1,
		(height - penaltyAreaHeight) / 2,
		penaltyAreaWidth,
		penaltyAreaHeight
	);
	// Right penalty area
	field.strokeRect(
		width - 1 - penaltyAreaWidth,
		(height - penaltyAreaHeight) / 2,
		penaltyAreaWidth,
		penaltyAreaHeight
	);

	// Goal areas (left and right)
	const goalAreaWidth = 50;
	const goalAreaHeight = 140;
	// Left goal area
	field.strokeRect(
		1,
		(height - goalAreaHeight) / 2,
		goalAreaWidth,
		goalAreaHeight
	);
	// Right goal area
	field.strokeRect(
		width - 1 - goalAreaWidth,
		(height - goalAreaHeight) / 2,
		goalAreaWidth,
		goalAreaHeight
	);

	// Penalty spots
	field.fillStyle = "rgb(254 254 254 / 35%)"; // "snow" color
	field.beginPath();
	field.arc(1 + penaltyAreaWidth - 18, height / 2, 3, 0, Math.PI * 2);
	field.fill();
	field.beginPath();
	field.arc(width - 1 - penaltyAreaWidth + 18, height / 2, 3, 0, Math.PI * 2);
	field.fill();

	// Penalty arcs ('D')
	const penaltyArcRadius = 80;
	// Left arc
	field.save();
	field.beginPath();
	field.arc(
		1 + penaltyAreaWidth,
		height / 2,
		penaltyArcRadius,
		1.5 * Math.PI,
		0.5 * Math.PI,
		false
	);
	field.restore();
	field.stroke();
	// Right arc
	field.save();
	field.beginPath();
	field.arc(
		width - 1 - penaltyAreaWidth,
		height / 2,
		penaltyArcRadius,
		0.5 * Math.PI,
		1.5 * Math.PI,
		false
	);
	field.restore();
	field.stroke();

	// Corner arcs
	const cornerArcRadius = 20;
	field.strokeStyle = "rgb(254 254 254 / 35%)"; // "snow" color
	field.lineWidth = 1;
	field.beginPath();
	field.arc(1, 1, cornerArcRadius, 0, 0.5 * Math.PI, false);
	field.stroke();
	field.beginPath();
	field.arc(width - 1, 1, cornerArcRadius, 0.5 * Math.PI, Math.PI, false);
	field.stroke();
	field.beginPath();
	field.arc(1, height - 1, cornerArcRadius, 1.5 * Math.PI, 0, false);
	field.stroke();
	field.beginPath();
	field.arc(
		width - 1,
		height - 1,
		cornerArcRadius,
		Math.PI,
		1.5 * Math.PI,
		false
	);
	field.stroke();
};
